/**
 * @desc 获取最后的ebs汇率
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.EbsRateResponse>;
export function request(
  params: API.basics.exchangeRateFacadeImpl.getLastEbsRate.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getLastEbsRate`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
